// TODO: see about pulling these from the content-model lib (vulnerableCountryIsoCodes, programCountriesByRegion)
export const africaCountries = 'BF,ET,GH,KE,RW,TZ,TG,UG';
export const vulnerableAfricaCountries = 'BF,ET,RW,TG,TZ,UG';
export const asiaCountries = 'BD,ID,LK,PH,TH';
export const vulnerableAsiaCountries = 'BD';
export const caribbeanCountries = 'DO,GT,HN,HT,MX,NI,SV';
export const vulnerableCaribbeanCountries = 'HT';
export const southAmericaCountries = 'BO,BR,CO,EC,PE';
export const allVulnerableCountrues = 'BF,ET,RW,TG,TZ,UG,BD,HT';

const regionToCountries: Record<string, string> = {
  africa: africaCountries,
  asia: asiaCountries,
  caribbean: caribbeanCountries,
  southAmerica: southAmericaCountries,
};

const regionToVulnerableCountries: Record<string, string> = {
  africa: vulnerableAfricaCountries,
  asia: vulnerableAsiaCountries,
  caribbean: vulnerableCaribbeanCountries,
  southAmerica: southAmericaCountries,
};

export const filteredCountries = (
  causes?: string | null,
  location?: string | null,
) => {
  if (!location) {
    return null;
  }

  if (causes === 'vulnerableExploitation') {
    return regionToVulnerableCountries[location] ?? allVulnerableCountrues;
  }

  return regionToCountries[location] ?? location;
};
